export function prettyPrintDuration(duration_in_ms)
{
    if ( duration_in_ms == null || duration_in_ms < 1000 )
        return 'none';

    let ms_in_seconds = 1000;
    let ms_in_minutes = 60*ms_in_seconds;
    let ms_in_hours = ms_in_minutes*60;
    let ms_in_days = ms_in_hours * 24;

    if ( duration_in_ms % ms_in_days == 0 )
    {
        let days = duration_in_ms / ms_in_days;

        if ( days == 1 ) return "1 day";
        return days+" days";
    }

    if ( duration_in_ms % ms_in_hours == 0)
    {
        let hours = duration_in_ms / ms_in_hours;

        if ( hours == 1 ) return "1 hour";
        return hours+" hours";
    }

    if ( duration_in_ms % ms_in_minutes == 0 )
    {
        let min = duration_in_ms / ms_in_minutes;
        if ( min == 1 ) return "1 minute";
        return min+" minutes";
    }

    let sec = Math.round(duration_in_ms / ms_in_seconds);
    if ( sec == 1 ) return '1 second';
    return sec+" seconds";
}

//Provides ability to configure the number of time units to show.
export function prettyPrintDurationv2(duration_in_ms, options = {}) {
    // Default options: show a maximum of 2 time units.
    const { maxUnits = 2 } = options;
    
    if ( duration_in_ms == null || duration_in_ms === 0)
        return 'N/A';

    if (duration_in_ms < 500) {
        return '< 1 second';
    }

    // Round to the nearest second to simplify calculations.
    let total_seconds = Math.round(duration_in_ms / 1000);
    if (total_seconds === 0) {
        return '< 1 second';
    }

    const seconds_in_minute = 60;
    const seconds_in_hour = seconds_in_minute * 60;
    const seconds_in_day = seconds_in_hour * 24;

    // Calculate each unit of time.
    const days = Math.floor(total_seconds / seconds_in_day);
    const hours = Math.floor((total_seconds % seconds_in_day) / seconds_in_hour);
    const minutes = Math.floor((total_seconds % seconds_in_hour) / seconds_in_minute);
    const seconds = total_seconds % seconds_in_minute;

    // Helper to add a plural 's' if needed.
    const pluralize = (count, noun) => `${count} ${noun}${count !== 1 ? 's' : ''}`;

    // Build an array of all non-zero time parts.
    const allParts = [];
    if (days > 0) allParts.push(pluralize(days, 'day'));
    if (hours > 0) allParts.push(pluralize(hours, 'hour'));
    if (minutes > 0) allParts.push(pluralize(minutes, 'minute'));
    if (seconds > 0) allParts.push(pluralize(seconds, 'second'));

    // Determine if the output is an estimate by checking if we have more parts than we will show.
    const isEstimate = allParts.length > maxUnits;

    // Limit the parts to the maxUnits specified.
    const conciseParts = allParts.slice(0, maxUnits);

    // Join the parts and add the tilde prefix if it's an estimate.
    let result = conciseParts.join(', ');
    if (isEstimate) {
        result = `~${result}`;
    }

    return result;
}

export function getHumanReadableAge(time, now)
{
    if ( now == null )
        now = new Date().getTime();

    var time_as_date = new Date(time);
    var now_as_date = new Date(now);

    var age_in_ms = now - time;
    var age_in_minutes = age_in_ms / 1000 / 60;
    var age_in_days = age_in_minutes / 60 / 24;

    if ( age_in_minutes < 1 )
        return "now";

    if ( age_in_minutes < 60 )
    {
        return Math.round(age_in_minutes)+" min";
    }

    if ( age_in_days <= 1 && time_as_date.getDate() == now_as_date.getDate() )
    {
       return getPeriodClockTime(time);
    }

    if ( age_in_days < 7 )
    {
        return getShortDayName(time);
    }

    return time_as_date.getDate() + " "+getShortMonthName(time);
}

export function getTimeAndDate(time)
{
    let date_str = getISODate(time);
    let today_str = getISODate(new Date().getTime());

    if ( date_str == today_str )
    {
        return getPeriodClockTime(time);
    }

    return getPeriodClockTime(time) + ' ('+getISODate(time)+')';
}

export function getMMDDYYYY(time)
{
    let date = new Date(time);

    let month = date.getMonth()+1;
    let day = date.getDate();
    let year = date.getFullYear();

    return month+'/'+day+'/'+year;
}

export function getISODate(time)
{
    let date = new Date(time);

    let month = date.getMonth()+1;
    let day = date.getDate();
    let year = date.getFullYear();

    month = ''+month;
    day = ''+day;
    year = ''+year;

    if ( day.length == 1 ) day = '0'+day;
    if ( month.length == 1 ) month = '0'+month;

    return year+'-'+month+'-'+day;
}

export function toISODateString(date)
{
    let month = date.getMonth()+1;
    let day = date.getDate();
    let year = date.getFullYear();

    if ( month < 10 ) month = '0'+month;
    if ( day < 10 ) day = '0'+day;

    return year+'-'+month+'-'+day;
}

export function toISOFirstDayOfMonth(date)
{
    date = new Date(date.getFullYear(), date.getMonth(),1);
    return toISODateString(date);
}

export function toISOLastDayOfMonth(date)
{
    date = new Date(date.getFullYear(), date.getMonth()+1,0);
    return toISODateString(date);
}

export function getPeriodClockTime(time)
{
    const time_as_date = new Date(time);

    var mil_hour = time_as_date.getHours();
    var period = "AM";
    var hour;


    if ( mil_hour < 12 )
    {
        hour = mil_hour;
    }
    else
    {
        hour = mil_hour - 12;
        period = "PM";
    }

    if ( hour == 0 ) hour = 12;

    var minutes = time_as_date.getMinutes() <= 9 ? '0'+time_as_date.getMinutes() : ''+time_as_date.getMinutes();

    return hour+':'+minutes+' '+period;
}

export function getPeriodClockTimeFromDate(time_as_date)
{
    var mil_hour = time_as_date.getHours();
    var period = "am";
    var hour;


    if ( mil_hour < 12 )
    {
        hour = mil_hour;
    }
    else
    {
        hour = mil_hour - 12;
        period = "pm";
    }

    if ( hour == 0 ) hour = 12;

    var minutes = time_as_date.getMinutes() <= 9 ? '0'+time_as_date.getMinutes() : ''+time_as_date.getMinutes();

    return hour+':'+minutes+period;
}

export function getShortDayName(time)
{
    const day_of_week = new Date(time).getDay();

    if ( day_of_week == 0 ) return "Sun";
    if ( day_of_week == 1 ) return "Mon";
    if ( day_of_week == 2 ) return "Tue";
    if ( day_of_week == 3 ) return "Wed";
    if ( day_of_week == 4 ) return "Thu";
    if ( day_of_week == 5 ) return "Fri";
    if ( day_of_week == 6 ) return "Sat";

   return "unknown";
}

export function getDayName(time)
{
    const day_of_week = new Date(time).getDay();

    if ( day_of_week == 0 ) return "Sunday";
    if ( day_of_week == 1 ) return "Monday";
    if ( day_of_week == 2 ) return "Tuesday";
    if ( day_of_week == 3 ) return "Wednesday";
    if ( day_of_week == 4 ) return "Thursday";
    if ( day_of_week == 5 ) return "Friday";
    if ( day_of_week == 6 ) return "Saturday";

   return "unknown";
}

export function getShortMonthName(time)
{
    const month = new Date(time).getMonth();

    if ( month == 0 ) return "Jan";
    if ( month == 1 ) return "Feb";
    if ( month == 2 ) return "Mar";
    if ( month == 3 ) return "Apr";
    if ( month == 4 ) return "May";
    if ( month == 5 ) return "Jun";
    if ( month == 6 ) return "Jul";
    if ( month == 7 ) return "Aug";
    if ( month == 8 ) return "Sep";
    if ( month == 9 ) return "Oct";
    if ( month == 10 ) return "Nov";
    if ( month == 11 ) return "Dec";

   return "unknown";
}

export function getHumanReadableTimelineTime(time, now)
{
    if ( now == null )
        now = new Date().getTime();

    var time_as_date = new Date(time);
    var now_as_date = new Date(now);

    var age_in_ms = now - time;
    var age_in_minutes = age_in_ms / 1000 / 60;
    var age_in_days = age_in_minutes / 60 / 24;

    if ( age_in_days <= 1 && time_as_date.getDate() == now_as_date.getDate() )
    {
        return getPeriodClockTime(time);
    }

    if ( age_in_days < 7 )
    {
        return getShortDayName(time)+" - "+getPeriodClockTime(time);
    }

    if ( time_as_date.getFullYear() == now_as_date.getFullYear() )
        return time_as_date.getDate() + " "+getShortMonthName(time);

    return time_as_date.getDate() + " "+getShortMonthName(time)+" "+time_as_date.getFullYear();
}

export function getLongTimestamp(time, now)
{
    if ( now == null )
        now = new Date().getTime();

    var time_as_date = new Date(time);
    var now_as_date = new Date(now);

    var age_in_ms = now - time;
    var age_in_minutes = age_in_ms / 1000 / 60;
    var age_in_days = age_in_minutes / 60 / 24;

    if ( time_as_date.getFullYear() != now_as_date.getFullYear() )
    {
        return getShortDayName(time)+", "+getShortMonthName(time)+" "+time_as_date.getDate()+" "+time_as_date.getFullYear()+" @ "+getPeriodClockTime(time);
    }

    return getShortDayName(time)+", "+getShortMonthName(time)+" "+time_as_date.getDate()+" @ "+getPeriodClockTime(time);
}

export function getHumanReadableDuration(time)
{
    function label(qty, single, plural)
    {
        return qty == 1 ? single : plural;
    }

    if ( time < 1000 )
    {
        return "Less than one second";
    }

    if ( time < 60000 )
    {
        let seconds = Math.floor(time/1000);
        return seconds + " "+label(seconds, "second", "seconds");
    }

    if ( time < 3600000 )
    {
        let minutes = Math.floor(time/60000);
        return minutes + " "+label(minutes, "minute", "minutes");
    }

    let hours = Math.floor(time/3600000);
    let minutes = Math.floor((time - hours*3600000)/60000);

    if ( minutes == 0 )
        return hours+" "+label(hours,"hour","hours");

    return hours + " "+label(hours,"hour","hours")+", "+minutes+" "+label(minutes,"minute","minutes");
}

export function getDurationAsMilliseconds(duration)
{
    if ( typeof duration != 'string' ) return duration;

    duration = duration.toLowerCase();

    let value = parseInt(duration);

    if ( Number.isNaN(value) )
        return null;

    if ( duration.includes('year') || duration.includes('yr') )
    {
        return value * 365 * 24 * 60 * 60 * 1000;
    }

    if ( duration.includes('day') )
    {
        return value * 24 * 60 * 60 * 1000;
    }

    if ( duration.includes('hour') || duration.includes('hr') )
    {
        return value * 60 * 60 * 1000;
    }

    if ( duration.includes('min') )
    {
        return value * 60 * 1000;
    }

    if ( duration.includes('sec') )
    {
        return value * 1000;
    }

    return value;
}

export function wallTimePrettyPrintUs(wall_time)
{
    let parts = wall_time.split(':', 2);

    let hour = parseInt(parts[0]);

    if ( hour > 12 )
    {
        hour = hour - 12;
        return hour+':'+parts[1]+' PM';
    }
    else if ( hour == 12 )
    {
        return hour+':'+parts[1]+' PM';
    }
    else if ( hour == 0 )
    {
        return '12:'+parts[1]+' AM';
    }
    else
    {
        return hour+':'+parts[1]+' AM';
    }
}

/**
 * Convert MM/DD/YYYY string to YYYY-MM-DD
 * Handles simplified formats like "1/1/2020"
 * @param {string} mmddyyyy - Date in MM/DD/YYYY format
 * @returns {string} - Date in YYYY-MM-DD format or original input if invalid
 */
export function mmddyyyyToISOFormat(mmddyyyy)
{
    if (!mmddyyyy) return null;

    try {
        // Parse MM/DD/YYYY format
        const parts = mmddyyyy.split('/');
        if (parts.length !== 3) return mmddyyyy;

        // Parse the date components
        let month = parts[0].trim();
        let day = parts[1].trim();
        let year = parts[2].trim();

        // Pad month and day with leading zeros if needed
        if (month.length === 1) month = '0' + month;
        if (day.length === 1) day = '0' + day;

        // Validate parts after padding
        if (month.length !== 2 || day.length !== 2 || year.length !== 4) return mmddyyyy;

        // Validate month and day ranges
        const monthNum = parseInt(month, 10);
        const dayNum = parseInt(day, 10);

        if (monthNum < 1 || monthNum > 12) return mmddyyyy;

        // Simple validation for days in month
        const maxDays = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (dayNum < 1 || dayNum > maxDays[monthNum - 1]) return mmddyyyy;

        // Convert to YYYY-MM-DD
        return `${year}-${month}-${day}`;
    } catch (e) {
        // If any error occurs during parsing, return the original input
        return mmddyyyy;
    }
}

// Convert YYYY-MM-DD string to MM/DD/YYYY
export function isoToMMDDYYYY(iso_date)
{
    if (!iso_date) return '';

    // Check if it's already in MM/DD/YYYY format
    if (iso_date.includes('/')) return iso_date;

    // Convert from ISO format (YYYY-MM-DD) to MM/DD/YYYY
    const parts = iso_date.split('-');
    if (parts.length !== 3) return iso_date;

    return `${parts[1]}/${parts[2]}/${parts[0]}`;
}

// Format an array of dates, ensuring they're all in ISO format
export function formatDateArray(date_array, validate_function)
{
    if (!Array.isArray(date_array)) return [];

    return date_array.map(date => {
        if (typeof date === 'string') {
            if (date.includes('/')) {
                return mmddyyyyToISOFormat(date);
            } else if (validate_function && validate_function(date)) {
                return date;
            }
        }
        return null;
    }).filter(date => date !== null);
}

// Convert an array of dates to display format (MM/DD/YYYY)
export function formatDateArrayForDisplay(date_array)
{
    if (!Array.isArray(date_array)) return [];

    return date_array.map(date => {
        if (typeof date === 'string') {
            if (date.includes('-')) {
                return isoToMMDDYYYY(date);
            }
        }
        return date;
    });
}

export function toMMDDYYYY(date_str)
{
    // If the input is already in a valid date format, return it
    if (typeof date_str === 'string') {
        // Check if it's already in MM/DD/YYYY format with possible single digits
        const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/;
        const match = date_str.match(dateRegex);

        if (match) {
            const month = match[1].padStart(2, '0');
            const day = match[2].padStart(2, '0');
            let year = match[3];

            return `${month}/${day}/${year}`;
        }
    }
    
    return date_str;
}

export default {
     getHumanReadableAge,
     getPeriodClockTime,
     getHumanReadableTimelineTime,
     getMMDDYYYY,
     getHumanReadableDuration,
     getTimeAndDate,
     toISODateString,
     toISOFirstDayOfMonth,
     toISOLastDayOfMonth,
     prettyPrintDuration,
     prettyPrintDurationv2,
     getLongTimestamp,
     getDurationAsMilliseconds,
     wallTimePrettyPrintUs,
     mmddyyyyToISOFormat,
     isoToMMDDYYYY,
     formatDateArray,
     formatDateArrayForDisplay,
     toMMDDYYYY,
     getISODate,
     getPeriodClockTimeFromDate,
     getShortDayName,
     getDayName,
     getShortMonthName
};